import BaseEntity from '../BaseEntity.model';

import { StatusEnum } from '../../Enum/StatusEnum';
import { CreatedBy } from '../Shared/CreatedBy.model';
import { HospitalizationModel } from './HospitalizationModel.model';

export default interface IMentalHealthTreatmentHistoryModel extends BaseEntity {
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    RecievedMentalHealthTreatment: string;
    TherapistName: string;
    ClinicName: string;
    ReasonForTreatment: string;
    Diagnosis: string;
    IsTherapyHelpful: string;
    MemberComments: string;
    AdmittedToTreatmentFacility: string;
    MemberHospitalizations: HospitalizationModel[];
    AssessedForSMI: string;
    AssessedForSMIComments: string;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    IsRecievedMentalHealthTreatmentAi: boolean;
    IsTherapistNameAi: boolean;
    IsClinicNameAi: boolean;
    IsReasonForTreatmentAi: boolean;
    IsDiagnosisAi: boolean;
    IsTherapyHelpfulAi: boolean;
    IsMemberCommentsAi: boolean;
    IsAdmittedToTreatmentFacilityAi: boolean;
    IsAssessedForSMIAi: boolean;
    IsAssessedForSMICommentsAi: boolean;
}

export class MentalHealthTreatmentHistoryModel implements IMentalHealthTreatmentHistoryModel {
    Id: string;
    MemberId: string;
    RecordingDate: Date;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;
    RecievedMentalHealthTreatment: string;
    TherapistName: string;
    ClinicName: string;
    ReasonForTreatment: string;
    Diagnosis: string;
    IsTherapyHelpful: string;
    MemberComments: string;
    AdmittedToTreatmentFacility: string;
    MemberHospitalizations: HospitalizationModel[];
    AssessedForSMI: string;
    AssessedForSMIComments: string;
    IsAssessmentCompleted: boolean;
    AssessmentStatus: StatusEnum;
    IsRecievedMentalHealthTreatmentAi: boolean;
    IsTherapistNameAi: boolean;
    IsClinicNameAi: boolean;
    IsReasonForTreatmentAi: boolean;
    IsDiagnosisAi: boolean;
    IsTherapyHelpfulAi: boolean;
    IsMemberCommentsAi: boolean;
    IsAdmittedToTreatmentFacilityAi: boolean;
    IsAssessedForSMIAi: boolean;
    IsAssessedForSMICommentsAi: boolean;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.RecievedMentalHealthTreatment = '';
        this.AdmittedToTreatmentFacility = '';
        this.MemberHospitalizations = [];
        this.IsAssessmentCompleted = false;
        this.AssessmentStatus = 0;
    }
}
